import { EyeIcon } from "@heroicons/react/24/outline";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@nextui-org/react";
import { month } from "../../../../../services/enum";

export default function ModalDetailProduction({ item }) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <Button isIconOnly size="sm" color="primary" onPress={onOpen}>
        <EyeIcon className="size-4" />
      </Button>
      <Modal scrollBehavior="inside" size="xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Detail Laporan Produksi</ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Perusahaan</span>
                    <span className="text-sm font-medium">{item.company.name}</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Periode</span>
                    <span className="text-sm font-medium">{item.period.name}</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Bulan</span>
                    <span className="text-sm font-medium">{month[item.bulan - 1]}</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Tahun</span>
                    <span className="text-sm font-medium">{item.tahun}</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Tipe Produk</span>
                    <span className="text-sm font-medium">{item?.tipeProduk}</span>
                  </div>
                  {item?.tipeProduk === "Bahan Berbahaya dan Beracun" && (
                    <>
                      <div className="flex flex-col">
                        <span className="text-xs text-ink-400 uppercase">Jenis B3</span>
                        <span className="text-sm font-medium">{item?.dataBahanB3?.namaBahanKimia ?? "-"}</span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-xs text-ink-400 uppercase">Nomor Registrasi</span>
                        <span className="text-sm font-medium">{item?.registrasi?.BahanB3Registrasi[0].nomor_reg_bahan ?? "-"}</span>
                      </div>
                    </>
                  )}
                  {item?.tipeProduk === "Non Bahan Berbahaya dan Beracun" && (
                    <div className="flex flex-col">
                      <span className="text-xs text-ink-400 uppercase">Nama Produk</span>
                      <span className="text-sm font-medium">{item?.namaProduk ?? "-"}</span>
                    </div>
                  )}
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Jumlah Produksi</span>
                    <span className="text-sm font-medium">{item?.jumlahB3Dihasilkan} Kg</span>
                  </div>
                  {/* <div className='flex flex-col col-span-2'>
                                    <span className='text-xs text-ink-400 uppercase'>Proses Produksi</span>
                                    <span className='text-sm font-medium'>{item?.prosesProduksi ?? '-'}</span>
                                </div> */}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Tutup
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
